/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

/* eslint-disable import/max-dependencies */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SetGlobalStyle } from "@nordcloud/gnui";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/global.css";
import { GlobalSwitch } from "~/GlobalSwitch";
import { AccessProvider } from "~/services/access";
import { ApolloProvider } from "~/services/apollo";
import { Auth0ProviderWithHistory, auth0Client, AuthWall } from "~/services/auth";
import { ErrorFallback } from "./components";

const container = document.getElementById("root");
const root = createRoot(container as HTMLElement); // createRoot(container!) if you use TypeScript

root.render(
  <ErrorBoundary
    fallbackRender={({ error, resetErrorBoundary }) => (
      <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} message="Go to homepage" />
    )}
    onReset={() => (window.location.href = "/")}
  >
    <BrowserRouter>
      <Auth0ProviderWithHistory client={auth0Client}>
        <AuthWall>
          <SetGlobalStyle customScrollbars />
          <ApolloProvider>
            <StrictMode>
              <AccessProvider>
                <GlobalSwitch />
                <SetGlobalStyle />
                <ToastContainer />
              </AccessProvider>
            </StrictMode>
          </ApolloProvider>
        </AuthWall>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </ErrorBoundary>
);
